<script>
import icons from '../../assets/icons';

export default {
  name: 'Svgicon',
  props: {
    name: {
      type: String,
      required: true,
    },
    color: {
      type: Boolean,
      default: false,
    },
    width: [String, Number],
    height: [String, Number],
    stroke: Boolean,
    direction: {
      type: String,
      validate: (value) => ['up', 'left', 'right', 'down'].includes(value),
    },
  },
  render(h) {
    const iconName = this.name.split('-')
      .map((icon) => icon.charAt(0).toUpperCase() + icon.slice(1))
      .join('');

    return h(
      icons[iconName],
      {
        class: [
          'svg-icon',
          `svg-${this.name}`,
          !this.color ? 'svg-fill' : '',
          this.direction ? `svg-${this.direction}` : '',
          this.stroke ? 'svg-stroke' : '',
        ],
        style: {
          width: this.width ? this.width : '',
          height: this.height ? this.height : '',
        },
      },
    );
  },
};
</script>

<style>
.svg-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  line-height: 1em;
  color: inherit;
  fill: none;
  stroke: none;
  vertical-align: middle;
}

.svg-fill {
  fill: currentColor;
}

.svg-stroke {
  stroke: currentColor;
}

.svg-up {
  /*default*/
  transform: rotate(0deg);
}

.svg-right {
   transform: rotate(90deg);
}

.svg-down {
  transform: rotate(180deg);
}

.svg-left {
  transform: rotate(-90deg);
}
</style>



// WEBPACK FOOTER //
// src/components/UI/Svgicon.vue